import styles from './BgVideoWord.module.css';

import bgVideo from '../../../assets/video/bgVideoWord.webm';
import bgPoster from '../../../assets/images/bgPosterWord.webp';
import { useEffect, useRef } from 'react';

export const BgVideoWord = ({ delay }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    let timer = setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.play();
      }
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={styles.bgVideoWrapper}>
      <video
        ref={videoRef}
        playsInline
        muted="muted"
        loop
        poster={bgPoster}
        autoPlay={false}
      >
        <source src={bgVideo} type="video/webm" />
      </video>
    </div>
  );
};
